import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { KYMW7403Component } from "./kymw7403.component";

import { GetOutputTargetService } from "./api-services/get-output-target.service";
import { OutputRememberGoodsInfoService } from "./api-services/output-remember-goods-info.service";
import { OutputRememberGoodsDiffService } from "./api-services/output-remember-goods-diff.service";

@NgModule ({
  imports: [
    CommonModule,
    AppCommonsModule,
    FormsModule,
    PlessSharedModule,
    WjNavModule,
  ],
  declarations: [
    KYMW7403Component,
  ],
  providers: [
    GetOutputTargetService,
    OutputRememberGoodsInfoService,
    OutputRememberGoodsDiffService,
  ]
})

export class KYMW7403Module {}